// This is a bit of a risky approach but unless we move new order context at app level
// I don't see any way to communicate things from other parts of the app into the context...
import { createEventBusHook } from '@libs/components'

type AppEventType = 'orders.new.context.clear'

export const useAppEvents = createEventBusHook<AppEventType>()
